import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services/useTrackingEvent';

import { useCreateContentPopup } from '../CreateContentPopup';

export const useHandlers = () => {
  const openCreateContentPopup = useCreateContentPopup();
  const trackEvent = useTrackingEvent();

  const handleNewProjectClick = useCallback(() => {
    trackEvent(events.DASHBOARD.clickedCreateProjectMenuButton, {
      page: events.EVENT_PAGE.homePage,
    });

    // TODO: maybe move these events to "What type of content are you creating?" popup
    // trackEvent(events.DASHBOARD.clickedCreateDataDrivenButton, {
    //   page: events.EVENT_PAGE.homePage,
    // });
    // trackEvent(events.DASHBOARD.clickedCreateBlogButton, {
    //   page: events.EVENT_PAGE.homePage,
    // });

    openCreateContentPopup();
  }, [openCreateContentPopup, trackEvent]);

  return {
    handleNewProjectClick,
  };
};
